module.exports = __webpack_public_path__ + "mods/slumgud_-_seven_eigth.mod";